import React from "react"
import { useLocation } from "react-router-dom"
import { buttonColor } from "constants/layout"
import { Button, Input } from "reactstrap"

const Modal = ({
  action,
  toggle,
  onClick,
  onChange = () => {},
  values = {},
  loading,
}) => {
  const { descripcion, nros } = action ?? {}
  const { pathname } = useLocation()

  return (
    <>
      <div className="my-4 d-flex flex-column gap-4">
        <p className="mb-0">
          ¿Desea {descripcion?.toLowerCase()}{" "}
          {nros?.length > 1 ? "las solicitudes?" : "la solicitud?"}
        </p>
        {descripcion !== "Aprobar" &&
          descripcion !== "Continuar" &&
          descripcion !== "Rechazar" &&
          (pathname.includes("/solicitud/") ||
            pathname.includes("/solicitudes")) && (
            <div>
              <p className="mb-2">Motivo</p>
              <Input
                type="textarea"
                name="motivoDevolucion"
                onChange={onChange}
                value={values.motivoDevolucion}
              />
            </div>
          )}
      </div>
      <div className="d-flex justify-content-end gap-2">
        <Button
          type="submit"
          className="shadow-none mt-1"
          color={buttonColor[descripcion]}
          form="modalId"
          onClick={onClick}
          disabled={loading}
        >
          {loading ? "cargando..." : descripcion}
        </Button>
        <Button
          color="light"
          className="shadow-none mt-1"
          onClick={toggle}
          disabled={loading}
        >
          Cancelar
        </Button>
      </div>
    </>
  )
}

export default Modal
